import {useSelector} from "react-redux";

import {SearchIcon} from "@pg-design/icons-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {SEARCH_FORM_FOCUS_HASH} from "../../search/constants/search_form_focus_hash";
import {ViewType} from "../../view_type/ViewType";

const searchElement = {
    title: "Szukaj ofert",
    icon: <SearchIcon size="2.2" />,
    onClick: () => {
        window.location.href = rpAppLink.offer.list() + SEARCH_FORM_FOCUS_HASH;
    }
};

export const useNavigationSearch = () => {
    const viewType = useSelector((state: IRPStore) => state.viewType.current);

    const shouldShowSearchElement = viewType ? [ViewType.OFFER, ViewType.PROPERTY].includes(viewType) : false;

    return shouldShowSearchElement ? searchElement : null;
};
